import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { JobApplicationLookupComponent } from './job-application-lookup.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule
  ],
  declarations: [JobApplicationLookupComponent],
  exports: [JobApplicationLookupComponent],
  providers: []
})
export class JobApplicationLookupModule { }
